import { render } from "./ArgonInput.vue?vue&type=template&id=8ef34966"
import script from "./ArgonInput.vue?vue&type=script&lang=js"
export * from "./ArgonInput.vue?vue&type=script&lang=js"
script.render = render

export default script